import { createSlice } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { AdminSettings } from '../../types/state';

const initialState: AdminSettings = {
  data: [],
  fetchingStatusSettings: false,
  error: null
};

export const settings = createSlice({
  name: 'VPO_' + NameSpace.Settings,
  initialState,
  reducers: {
    fetchSettingsRequest: (state) => {
      state.fetchingStatusSettings = true;
      state.error = null;
    },
    fetchSettingsSuccess: (state, action) => {
      state.fetchingStatusSettings = false;
      state.data = action.payload;
    },
    fetchSettingsFailure: (state, action) => {
      state.fetchingStatusSettings = false;
      state.error = action.payload;
    },
  },
});

export const { fetchSettingsRequest, fetchSettingsSuccess, fetchSettingsFailure } = settings.actions;
